// extracted by mini-css-extract-plugin
export default {"marker":"superviserApproveMarker_marker__hL3Ys","badge":"superviserApproveMarker_badge__zsZLn"};